import BordTooltip from 'components/BordTooltip/BordTooltip';
import BordOneToneIcon from '../../../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import NudosButton from '../../../../../../../../components/NudosComponents/NudosButton/NudosButton';
import { IToolInspectionDate, LOGISTIC_SERVICE_STATUS_NAME, TlogisticServiceStatus } from 'types/services';
import { copyClipboard } from 'utils/copyClipboard';
import { formatDateToPicker } from 'utils/formatDatesAndHours';
import { getCreateDSNSiteUrl, hasToolInspectionBeenEdited } from '../utils/logistic-service-tool-card.utils';

import './ToolDsnActions.scss';

export interface IToolDsnActionsProps {
  logisticServiceId?: number | null;
  inspectionDate?: IToolInspectionDate | null;
  logisticServiceStatusName?: TlogisticServiceStatus | null;
}

/**
 * Enlace y botón para copiar el link del DSN y redirigir a WMS para la generación del DSN de la herramienta.
 * Opcionalmente muestra la fecha de creación del DSN; la última actualización solo si hubo edición.
 * El botón "Crear DSN" solo está habilitado si el servicio logístico está en estado entregado.
 */
const ToolDsnActions = ({ logisticServiceId, inspectionDate, logisticServiceStatusName }: IToolDsnActionsProps) => {
  const { logisticServiceProductId, createdAt: dsnCreatedDate, updatedAt: dsnLastUpdatedDate } = inspectionDate || {};
  const dsnLinkUrl = getCreateDSNSiteUrl(logisticServiceId, logisticServiceProductId);
  const isServiceDelivered = logisticServiceStatusName === LOGISTIC_SERVICE_STATUS_NAME.DELIVERED;
  const hasLastUpdatedDate = hasToolInspectionBeenEdited(dsnCreatedDate, dsnLastUpdatedDate) && dsnLastUpdatedDate;

  const handleCopyDsnLink = async () => {
    if (!dsnLinkUrl) return;
    await copyClipboard({
      text: dsnLinkUrl,
      notificationMessage: 'Link copiado al portapapeles'
    });
  };

  const handleCreateDsn = () => {
    if (!dsnLinkUrl) return;
    window.open(dsnLinkUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="toolDsnActions">
      {isServiceDelivered && dsnLinkUrl && (
        <button type="button" className="copyDsnLink" onClick={handleCopyDsnLink}>
          Copiar link a DSN
        </button>
      )}

      <div className="dsnDates">
        {dsnCreatedDate && <span className="dsnDateItem">Fecha creada DSN: {formatDateToPicker(dsnCreatedDate)}</span>}
        {hasLastUpdatedDate && (
          <span className="dsnDateItem">Última fecha actualizada: {formatDateToPicker(dsnLastUpdatedDate)}</span>
        )}
      </div>

      {dsnLinkUrl && (
        <BordTooltip
          position="top"
          message={isServiceDelivered ? '' : 'El DSN se podrá crear cuando la herramienta esté en entregada'}
          customStyles="createDsnDisabledTooltip"
          customStylesTooltipContainer="createDsnButtonTooltipContainer"
        >
          <span className="createDsnButtonTooltipWrap">
            <NudosButton
              buttonText={!dsnCreatedDate ? 'Crear DSN' : 'Ver y editar DSN'}
              handleClick={handleCreateDsn}
              colorPalette="secondary"
              componentSize="extraSmall"
              customClassName="createDsnButton"
              buttonIcon={<BordOneToneIcon variant="document" standardSize={10} stroke="currentColor" />}
              iconPosition="right"
              isButtonDisabled={!isServiceDelivered}
            />
          </span>
        </BordTooltip>
      )}
    </div>
  );
};

export default ToolDsnActions;
